import { configureStore, isRejectedWithValue } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import themeReducer from './services/themeSlice';
import paginationReducer from './services/paginationSlice';
import helpSectionReducer from './services/helpSectionSlice';
import subscriptionModalReducer from './services/subscriptionModalSlice';
import communicationReducer from '../features/communication/communicationSlice';
import forumReducer from '../features/forum/forumSliece';
import { apiSlice, discourseApiSlice, prodApiSlice } from './services/apiSlice';
import { toast } from 'react-toastify';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import productUtils from './services/productUtils';
import imagesGallery from './services/imagesGallery';
import driverOrder from './services/driverOrder';
import products from './services/products';
import removeBackground from './services/removeBackground';
import Authorization from './services/Authorization';
import sideBar from './services/sideBar';

const rtkQueryErrorLogger = () => (next) => (action) => {
  // if 401 then redirect to /
  if (action?.payload?.status === 401) {
    toast.error('Session Expired');
    window.location.href = '/logout';

    return;
  }
  
  if (isRejectedWithValue(action)) {
    if (action?.payload?.data?.code !== 302 && action?.payload?.status !== 401) {
      toast.error(
        action?.payload?.data?.errors?.[0] ||
          action?.payload?.data?.error ||
          action?.payload?.error ||
          action?.payload?.data?.message ||
          'Something went wrong!',
      );
    }
  }

  return next(action);
};

const persistConfig = {
  key: 'theme',
  storage,
  blacklist: ['previewTheme'],
};
const persistedThemeReducer = persistReducer(persistConfig, themeReducer);

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [discourseApiSlice.reducerPath]: discourseApiSlice.reducer,
    [prodApiSlice.reducerPath]: prodApiSlice.reducer,
    auth: authReducer,
    communication: communicationReducer,
    forum: forumReducer,
    theme: persistedThemeReducer,
    pagination: paginationReducer,
    helpSection: helpSectionReducer,
    subscriptionModal: subscriptionModalReducer,
    productUtils: productUtils,
    imagesGallery: imagesGallery,
    driverOrder: driverOrder,
    authorization: Authorization,
    removeBackground: removeBackground,
    products: products,
    sideBar: sideBar,
  },
  middleware: (getDefaultMiddleware) => {
    return [
      rtkQueryErrorLogger,
      ...getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(apiSlice.middleware)
        .concat(discourseApiSlice.middleware)
        .concat(prodApiSlice.middleware),
    ];
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export default store;
